import React from "react"
// import {Link} from "gatsby"
import { Accordion, Card, Col, Container } from 'react-bootstrap'

const Faq = () => (
  <Container id="faq" className="mx-auto my-5">
    <Col className="faqTitle centerText">
      <h1>Frequently Asked Questions</h1>
    </Col>
    <Accordion className="faqDetails" defaultActiveKey="0">
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="0">
          <b>
            Q: How long does shipping take? A: We offer same-day shipping in the UK!
          </b>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <Card.Body>For a small extra fee, you can have your LaziSkin today!</Card.Body>
        </Accordion.Collapse>
      </Card>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="1">
          <b>
            Q: Does it hurt? A: No!
          </b>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="1">
          <Card.Body>The LaziSkin is totally pain-free.</Card.Body>
        </Accordion.Collapse>
      </Card>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="2">
          <b>
            Q: How long does it last? A: Weeks!
          </b>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="2">
          <Card.Body>
            Not only will your hair be gone for weeks, when it comes back, it will be thinner and less visible.
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="3">
          <b>
            Q: Does it require batteries? A: No!
          </b>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="3">
          <Card.Body>You'll plug your LaziSkin in, so .</Card.Body>
        </Accordion.Collapse>
      </Card>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="4">
          <b>
            Q: Is it suitable for all skin tones? A: Yes!
          </b>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="4">
          <Card.Body>The LaziSkin works on every shade of skin.</Card.Body>
        </Accordion.Collapse>
      </Card>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="5">
          <b>
            Q: Do you accept Clearpay? A: Yes we do!
          </b>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="5">
          <Card.Body>Get your LaziSkin today, pay for it in four!</Card.Body>
        </Accordion.Collapse>
      </Card>
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="6">
          <b>
            Q: Do you accept Klarna? A: Yes we do!
          </b>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="6">
          <Card.Body> Buy your LaziSkin to unlock silky-smooth skin today, and pay for it tomorrow.</Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  </Container>
)

export default Faq
